export default function isLinkToFile(link: string | undefined): boolean | undefined {
  if (!link || typeof link !== 'string') return
  link = link.split('?').shift()
  link = link?.replace('http://', '')
  link = link?.replace('https://', '')
  let path: string[] | undefined = link?.split('/')
  path?.shift()
  if (path?.length === 0) return false
  const fullPath = path?.join('/')
  const fileType: string | undefined = fullPath?.split('.').pop()
  if (!fileType || fileType === 'html' || fileType === 'php') return false
  return true
}
